import { render, staticRenderFns } from "./TimeClock.vue?vue&type=template&id=564cd2fc&scoped=true&"
import script from "./TimeClock.vue?vue&type=script&lang=js&"
export * from "./TimeClock.vue?vue&type=script&lang=js&"
import style0 from "./TimeClock.vue?vue&type=style&index=0&id=564cd2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564cd2fc",
  null
  
)

export default component.exports